import {
  CreateGUFStartRegistrationTask,
  EditGUFStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

/**
 * Schema for DesignLoop within a DesignInstallation
 */
export const designLoopSchema = addSchema<
  (
    | CreateGUFStartRegistrationTask
    | EditGUFStartRegistrationTask
  )["sourcedocumentData"]["designInstallations"][number]["designLoops"]
>({
  type: "array",
  title: "Bodemlusen",
  minItems: 0,
  items: {
    type: "object",
    title: "Bodemlus",
    required: ["designLoopId", "designLoopPos", "startDate", "endDate"],
    properties: pickGufPrimitiveLibraryFields([
      "designLoopId",
      "designLoopPos",
      "loopType",
      "startDate",
      "endDate",
      "geometryType",
    ]),
  },
});
